"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextElement = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Primary UI component for Text
 * Text Design System
 * https://www.figma.com/file/e3tx1qa6K2KrMgVVFDSIT3/Nutrafol---Website?node-id=9%3A1329
 */
var validElements = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "span", "button"];
var invalidElements = validElements.filter(function (el) {
  return !["span", "button"].includes(el);
});
var showWarning = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (window.location.hostname.includes("localhost") || window.location.hostname.includes("staging"));
var TextElement = function TextElement(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? "" : _ref$text,
    element = _ref.element,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onKeyPress = _ref.onKeyPress,
    onKeyPress = _ref$onKeyPress === void 0 ? function () {} : _ref$onKeyPress,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    styles = _ref.styles,
    _ref$sanitize = _ref.sanitize,
    sanitize = _ref$sanitize === void 0 ? false : _ref$sanitize,
    children = _ref.children;
  var Element = validElements.includes(element) ? element : "p";
  // p can contain only Phrasing content  - span, button etc https://nutrafol.atlassian.net/browse/NT2-11229
  if (Element === "p") {
    invalidElements.forEach(function (el) {
      if (text && typeof text.includes === "function" && text.includes("<".concat(el))) {
        //replace all non Phrasing content with a SPAN
        showWarning && console.warn("TextElement: <".concat(el.toUpperCase(), "> in <P> replaced with <SPAN>"), text);
        var reg1 = new RegExp("(<".concat(el, ")"), "igm");
        var reg2 = new RegExp("(</".concat(el, ")"), "igm");
        text = text.replace(reg1, "<span").replace(reg2, "</span");
      }
    });
  }
  // styles located globally in application
  var StyledTextElement = /*#__PURE__*/(0, _base["default"])(Element, process.env.NODE_ENV === "production" ? {
    target: "e1yexmq90"
  } : {
    target: "e1yexmq90",
    label: "StyledTextElement"
  })(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9UZXh0RWxlbWVudC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2RDJDIiwiZmlsZSI6Ii4uL3NyYy9UZXh0RWxlbWVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIlxuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IERPTVB1cmlmeSBmcm9tIFwiZG9tcHVyaWZ5XCJcblxuLyoqXG4gKiBQcmltYXJ5IFVJIGNvbXBvbmVudCBmb3IgVGV4dFxuICogVGV4dCBEZXNpZ24gU3lzdGVtXG4gKiBodHRwczovL3d3dy5maWdtYS5jb20vZmlsZS9lM3R4MXFhNksyS3JNZ1ZWRkRTSVQzL051dHJhZm9sLS0tV2Vic2l0ZT9ub2RlLWlkPTklM0ExMzI5XG4gKi9cbmNvbnN0IHZhbGlkRWxlbWVudHMgPSBbXG4gIFwiaDFcIixcbiAgXCJoMlwiLFxuICBcImgzXCIsXG4gIFwiaDRcIixcbiAgXCJoNVwiLFxuICBcImg2XCIsXG4gIFwicFwiLFxuICBcInNwYW5cIixcbiAgXCJidXR0b25cIixcbl1cbmNvbnN0IGludmFsaWRFbGVtZW50cyA9IHZhbGlkRWxlbWVudHMuZmlsdGVyKFxuICAoZWwpID0+ICFbXCJzcGFuXCIsIFwiYnV0dG9uXCJdLmluY2x1ZGVzKGVsKVxuKVxuY29uc3Qgc2hvd1dhcm5pbmcgPVxuICB0eXBlb2Ygd2luZG93ID09PSBcIm9iamVjdFwiICYmXG4gICh3aW5kb3cubG9jYXRpb24uaG9zdG5hbWUuaW5jbHVkZXMoXCJsb2NhbGhvc3RcIikgfHxcbiAgICB3aW5kb3cubG9jYXRpb24uaG9zdG5hbWUuaW5jbHVkZXMoXCJzdGFnaW5nXCIpKVxuXG5leHBvcnQgY29uc3QgVGV4dEVsZW1lbnQgPSAoe1xuICB0ZXh0ID0gYGAsXG4gIGVsZW1lbnQsXG4gIG9uQ2xpY2sgPSAoKSA9PiB7fSxcbiAgb25LZXlQcmVzcyA9ICgpID0+IHt9LFxuICBjbGFzc05hbWUgPSBgYCxcbiAgc3R5bGVzLFxuICBzYW5pdGl6ZSA9IGZhbHNlLFxuICBjaGlsZHJlbixcbn0pID0+IHtcbiAgY29uc3QgRWxlbWVudCA9IHZhbGlkRWxlbWVudHMuaW5jbHVkZXMoZWxlbWVudCkgPyBlbGVtZW50IDogXCJwXCJcbiAgLy8gcCBjYW4gY29udGFpbiBvbmx5IFBocmFzaW5nIGNvbnRlbnQgIC0gc3BhbiwgYnV0dG9uIGV0YyBodHRwczovL251dHJhZm9sLmF0bGFzc2lhbi5uZXQvYnJvd3NlL05UMi0xMTIyOVxuICBpZiAoRWxlbWVudCA9PT0gYHBgKSB7XG4gICAgaW52YWxpZEVsZW1lbnRzLmZvckVhY2goKGVsKSA9PiB7XG4gICAgICBpZiAoXG4gICAgICAgIHRleHQgJiZcbiAgICAgICAgdHlwZW9mIHRleHQuaW5jbHVkZXMgPT09IFwiZnVuY3Rpb25cIiAmJlxuICAgICAgICB0ZXh0LmluY2x1ZGVzKGA8JHtlbH1gKVxuICAgICAgKSB7XG4gICAgICAgIC8vcmVwbGFjZSBhbGwgbm9uIFBocmFzaW5nIGNvbnRlbnQgd2l0aCBhIFNQQU5cbiAgICAgICAgc2hvd1dhcm5pbmcgJiZcbiAgICAgICAgICBjb25zb2xlLndhcm4oXG4gICAgICAgICAgICBgVGV4dEVsZW1lbnQ6IDwke2VsLnRvVXBwZXJDYXNlKCl9PiBpbiA8UD4gcmVwbGFjZWQgd2l0aCA8U1BBTj5gLFxuICAgICAgICAgICAgdGV4dFxuICAgICAgICAgIClcbiAgICAgICAgY29uc3QgcmVnMSA9IG5ldyBSZWdFeHAoYCg8JHtlbH0pYCwgXCJpZ21cIilcbiAgICAgICAgY29uc3QgcmVnMiA9IG5ldyBSZWdFeHAoYCg8LyR7ZWx9KWAsIFwiaWdtXCIpXG4gICAgICAgIHRleHQgPSB0ZXh0LnJlcGxhY2UocmVnMSwgXCI8c3BhblwiKS5yZXBsYWNlKHJlZzIsIFwiPC9zcGFuXCIpXG4gICAgICB9XG4gICAgfSlcbiAgfVxuICAvLyBzdHlsZXMgbG9jYXRlZCBnbG9iYWxseSBpbiBhcHBsaWNhdGlvblxuICBjb25zdCBTdHlsZWRUZXh0RWxlbWVudCA9IHN0eWxlZChFbGVtZW50KWBgXG5cbiAgaWYgKFJlYWN0LmlzVmFsaWRFbGVtZW50KHRleHQpKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxTdHlsZWRUZXh0RWxlbWVudFxuICAgICAgICBjbGFzc05hbWU9e2B0ZXh0ZWxlbWVudCAke2NsYXNzTmFtZX1gfVxuICAgICAgICBzdHlsZT17c3R5bGVzfVxuICAgICAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgICAgICBvbktleVByZXNzPXtvbktleVByZXNzfVxuICAgICAgPlxuICAgICAgICB7c2FuaXRpemUgPyBET01QdXJpZnkuc2FuaXRpemUodGV4dCwgeyBBTExPV0VEX1RBR1M6IFtdIH0pIDogdGV4dH1cbiAgICAgIDwvU3R5bGVkVGV4dEVsZW1lbnQ+XG4gICAgKVxuICB9XG5cbiAgaWYgKGNoaWxkcmVuKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxTdHlsZWRUZXh0RWxlbWVudFxuICAgICAgICBjbGFzc05hbWU9e2B0ZXh0ZWxlbWVudCAke2NsYXNzTmFtZX1gfVxuICAgICAgICBzdHlsZT17c3R5bGVzfVxuICAgICAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgICAgICBvbktleVByZXNzPXtvbktleVByZXNzfVxuICAgICAgPlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICA8L1N0eWxlZFRleHRFbGVtZW50PlxuICAgIClcbiAgfVxuXG4gIHJldHVybiAoXG4gICAgPFN0eWxlZFRleHRFbGVtZW50XG4gICAgICBjbGFzc05hbWU9e2B0ZXh0ZWxlbWVudCAke2NsYXNzTmFtZX1gfVxuICAgICAgc3R5bGU9e3N0eWxlc31cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICBvbktleVByZXNzPXtvbktleVByZXNzfVxuICAgICAgZGFuZ2Vyb3VzbHlTZXRJbm5lckhUTUw9e3tcbiAgICAgICAgX19odG1sOiBzYW5pdGl6ZVxuICAgICAgICAgID8gRE9NUHVyaWZ5LnNhbml0aXplKHRleHQsIHsgQUxMT1dFRF9UQUdTOiBbXSB9KVxuICAgICAgICAgIDogdGV4dCxcbiAgICAgIH19XG4gICAgLz5cbiAgKVxufVxuXG5UZXh0RWxlbWVudC5wcm9wVHlwZXMgPSB7XG4gIC8qKlxuICAgKiB0ZXh0IG9yIGh0bWwgc3RyaW5nIG9yIG5vZGVcbiAgICovXG4gIHRleHQ6IFByb3BUeXBlcy5vbmVPZlR5cGUoW1Byb3BUeXBlcy5zdHJpbmcsIFByb3BUeXBlcy5vYmplY3RdKSxcbiAgLyoqXG4gICAqIHdoYXQgZWxlbWVudCB0byByZW5kZXJcbiAgICovXG4gIGVsZW1lbnQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gIC8qKlxuICAgKiBPcHRpb25hbCBzdHJpbmcgb2YgY2xhc3Nlc1xuICAgKi9cbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAvKipcbiAgICogT3B0aW9uYWwgb2JqZWN0IG9mIHN0eWxlc1xuICAgKi9cbiAgc3R5bGVzOiBQcm9wVHlwZXMub2JqZWN0LFxuICAvKipcbiAgICogT3B0aW9uYWwgb25DbGljayBoYW5kbGVyXG4gICAqL1xuICBvbkNsaWNrOiBQcm9wVHlwZXMuZnVuYyxcbiAgLyoqXG4gICAqIE9wdGlvbmFsIG9uS2V5UHJlc3MgaGFuZGxlclxuICAgKi9cbiAgb25LZXlQcmVzczogUHJvcFR5cGVzLmZ1bmMsXG59XG5cblRleHRFbGVtZW50LmRlZmF1bHRQcm9wcyA9IHtcbiAgZWxlbWVudDogXCJwXCIsXG59XG4iXX0= */");
  if ( /*#__PURE__*/_react["default"].isValidElement(text)) {
    return /*#__PURE__*/_react["default"].createElement(StyledTextElement, {
      className: "textelement ".concat(className),
      style: styles,
      onClick: onClick,
      onKeyPress: onKeyPress
    }, sanitize ? _dompurify["default"].sanitize(text, {
      ALLOWED_TAGS: []
    }) : text);
  }
  if (children) {
    return /*#__PURE__*/_react["default"].createElement(StyledTextElement, {
      className: "textelement ".concat(className),
      style: styles,
      onClick: onClick,
      onKeyPress: onKeyPress
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(StyledTextElement, {
    className: "textelement ".concat(className),
    style: styles,
    onClick: onClick,
    onKeyPress: onKeyPress,
    dangerouslySetInnerHTML: {
      __html: sanitize ? _dompurify["default"].sanitize(text, {
        ALLOWED_TAGS: []
      }) : text
    }
  });
};
exports.TextElement = TextElement;
TextElement.propTypes = {
  /**
   * text or html string or node
   */
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /**
   * what element to render
   */
  element: _propTypes["default"].string,
  /**
   * Optional string of classes
   */
  className: _propTypes["default"].string,
  /**
   * Optional object of styles
   */
  styles: _propTypes["default"].object,
  /**
   * Optional onClick handler
   */
  onClick: _propTypes["default"].func,
  /**
   * Optional onKeyPress handler
   */
  onKeyPress: _propTypes["default"].func
};
TextElement.defaultProps = {
  element: "p"
};